import axios from 'axios';
axios.defaults.baseURL = "https://routers.zanserve.com/CbXkS1chaCtHBNEv/index.php";
axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';